// extracted by mini-css-extract-plugin
export default {"scroll-btn":"_-web-client-js-react-components-___ScrollButton-module__scroll-btn___1aO-s","visible":"_-web-client-js-react-components-___ScrollButton-module__visible___1ittb"};